import { render, staticRenderFns } from "./newLive.vue?vue&type=template&id=15379cf2&scoped=true"
import script from "./newLive.vue?vue&type=script&lang=js"
export * from "./newLive.vue?vue&type=script&lang=js"
import style0 from "./newLive.vue?vue&type=style&index=0&id=15379cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15379cf2",
  null
  
)

export default component.exports